'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import I18n from 'I18n';
import useInterval from '../hooks/useInterval';
import { halloweenQuips, defaultQuips } from '../constants/Quips';
import { isHalloween } from '../theming/operators/isHalloween';
import { useTheme } from 'styled-components';
import LanguageUtil from '../util/LanguageUtil';
var quipDelay = 5000;
var ENGLISH_LANG = 'en';
export default (function () {
  var theme = useTheme();
  var quips = isHalloween(theme) ? halloweenQuips : defaultQuips;

  var getQuip = function getQuip() {
    var pick = Math.floor(Math.random() * quips.length); // Remove quip so it's not reused and return it

    return quips.length && LanguageUtil.getUserLanguage() === ENGLISH_LANG ? quips.splice(pick, 1) : I18n.text('results.loading.text');
  };

  var _useState = useState(getQuip()),
      _useState2 = _slicedToArray(_useState, 2),
      quip = _useState2[0],
      setQuip = _useState2[1];

  useInterval(function () {
    return setQuip(getQuip());
  }, quipDelay);
  return /*#__PURE__*/_jsx("span", {
    children: quip
  });
});